import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AsyncSubject, of, Subject, throwError, timer } from 'rxjs';
import { catchError, debounceTime, delay, distinctUntilChanged, filter, map, mapTo, mergeMap, switchMap, tap } from 'rxjs/operators';
import { ShopService } from 'src/app/shared/api/shop.service';
import { getTipoSpedizioneStr } from 'src/app/shared/interfaces/custom/spedizione';
import { StoreService } from 'src/app/shared/services/store.service';
import Swal from 'sweetalert2';

declare let google: any;

const AUTOCOMPLETE_OPTIONS = {
  fields: ["address_components", "geometry.location"],
  types: ["address"],
  componentRestrictions: {country: ['it']}
}

@Component({
  selector: 'app-spedizioni-disponibili',
  templateUrl: './spedizioni-disponibili.component.html',
  styleUrls: ['./spedizioni-disponibili.component.scss'],
  animations: [
    trigger('startFinish', [
      state('start', style({
        left: 0
      })),
      state('end', style({
        left: 'calc(100% - 70px)'
      })),
      state('finish', style({
        left: 'calc(100% - 70px)'
      })),
      transition('start => end', [
        animate('5s')
      ]),
      transition('* => finish', [
        animate('.5s')
      ])
    ]),
  ],
})
export class SpedizioniDisponibiliComponent implements OnInit {
  @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;
  @ViewChild('addressInput', {static: false}) addressInput : ElementRef;

  modalRef: BsModalRef;

  animationState : 'start' | 'end' | 'finish' = 'start';

  config;
  configReady$ = new AsyncSubject();
  searchAdressSubject$ = new Subject<string>();
  google_addressSubject$ = new Subject<any>();
  
  constructor(private modalService: BsModalService, private store : StoreService,
    private shop : ShopService, private http : HttpClient, private cdr : ChangeDetectorRef,
    private zone : NgZone
    ) {
      this.http.get('/assets/config/config-info-spedizioni.json').pipe(
        catchError(err => of({
          "placeholder": "Verifica la tua copertura",
        }))
      ).subscribe((config:any) => {
        if (config && typeof config == 'object') {
          this.config = config;
          timer(0).subscribe(r => {
            this.configReady$.next(true);
            this.configReady$.complete();
          });
        }
      });
    }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.configReady$.subscribe(r => {
      let autocomplete = new google.maps.places.Autocomplete(this.addressInput.nativeElement, AUTOCOMPLETE_OPTIONS);
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
  
        if (place.geometry && place.address_components) {
            this.zone.run(() => {
              this.google_addressSubject$.next({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
                address: place.address_components
              });
            });
        }
      });

      this.searchAdressSubject$.pipe(
        filter(str => str.trim() != ''),
        tap(() => this.google_addressSubject$.next(false)),
        debounceTime(200),
        switchMap(addressLine => this.shop.getAddressByAddressLine(addressLine)),
      ).subscribe(result => {
        if (!result) {
            this.loadingAvailableShipping = false;
            return;
        }
        this.google_addressSubject$.next(result);
      },
      err => {
          this.loadingAvailableShipping = false;
          alert(err);
      });

      this.google_addressSubject$.pipe(
        tap(() => this.loadingAvailableShipping = true),
        switchMap(google_address => {
          if (!google_address)
            return of(false);
          let destinazione = this.google2MyTidyDest(google_address);
          if (!destinazione['cap'])
            return this.shop.getAddressByPos(destinazione.latitudine, destinazione.longitudine).pipe(
              map(google_address => this.google2MyTidyDest(google_address))
            );
          return of(destinazione);
        }),
      ).subscribe(destinazione => {
        if (destinazione) {
          this.openAvailableShippingsModal(destinazione);
        }
      })
    });
  }

  loadingAvailableShipping;

  openAvailableShippingsModal(address) {
    this.animationState = 'end';
    
    if (!address.stato)
      return alert("Impossibile recuperare il paese dal indirizzo, prova un'altro indirizzo");
    else {
      if (address.stato == "IT") {
        address.stato = 86;
      }
      else {
        return alert("L'indirizzo inserito non è completo o si trova fuori Italia. Prova a inserire un'altro indirizzo");
      }
    }

    this.currentShownAddress = address;

    return this.shop.getInfoSpedizioni(address).subscribe(spedizioni => {
      this.animationState = 'finish';

      this.loadingAvailableShipping = false;
      
      spedizioni.forEach(spedizione => this.transformSpedizione(spedizione));

      this.spedizioni = this.groupByType(spedizioni);

      // 500 -> 0
      timer(0).subscribe(() => {
        this.modalRef = this.modalService.show(this.template, {
          class: 'modal-dialog-centered modal-xl',
          ignoreBackdropClick: true
        });

        timer(500).subscribe(() => this.cdr.detectChanges());

        timer(200).subscribe(() => {
          this.animationState = 'start';
          this.loadingAvailableShipping = false;
        });

        let position = {
          'lat': this.currentShownAddress.latitudine,
          'lng': this.currentShownAddress.longitudine
        };

        this.google_map = new google.maps.Map(document.getElementById("google_map"), {
          zoom: 17,
          center: position,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          draggableCursor: 'crosshair',
          clickableIcons: false
        });

        this.marker = new google.maps.Marker({
            position: position,
            map: this.google_map,
            clickable: false
        });

        let clickInput$ = new Subject();

        clickInput$.pipe(
          switchMap((coords:any) => this.shop.getAddressByPos(coords.lat, coords.lng).pipe(
            map(google_address => ({...google_address, ...coords})),
          
            mergeMap((google_address : any) => {
              if (!google_address)
                return of(null);

              let address = this.google2MyTidyDest(google_address);

              if (!address.stato)
                return of(null);
              else {
                if (address.stato == "IT") {
                  address.stato = 86;
                }
                else {
                  return of(null);
                }
              }
          
              if (!address.citta || !address.prov || !address.cap)
                return of(null);

              this.currentShownAddress = address;

              return this.shop.getInfoSpedizioni(address).pipe(catchError(err => of([])));
            }),
            catchError(err => {
              return of(null);
            })
          ))
        ).subscribe((spedizioni: any) => {
          this.spinnerLoading = false;
          if (!spedizioni) {
            Swal.fire('', `Impossibile recuperare dati di indirizzo da posizione indicata. Indica un'altra posizione`, 'error');
            if (this.marker) {
              this.marker.setMap(null);
            }
  
            this.marker = new google.maps.Marker({
              position: {
                'lat': this.currentShownAddress.latitudine,
                'lng': this.currentShownAddress.longitudine
              },
              map: this.google_map,
              clickable: false
            });
            return;
          }

          spedizioni.forEach(spedizione => this.transformSpedizione(spedizione));
          this.spedizioni = this.groupByType(spedizioni);
        });

        this.google_map.addListener("click", (mapsMouseEvent) => {
            let pos = mapsMouseEvent.latLng.toJSON();

            if (this.marker) {
              this.marker.setMap(null);
            }

            this.marker = new google.maps.Marker({
              position: {
                'lat': pos.lat,
                'lng': pos.lng
              },
              map: this.google_map,
              clickable: false
            });

            this.spinnerLoading = true;

            clickInput$.next(pos);
        });

      });

    },
    err => {
      Swal.fire('', err, 'error');
      this.animationState = 'start';
      this.loadingAvailableShipping = false;
    });
  }

  spedizioni;

  currentShownAddress;

  google_map;
  marker;

  spinnerLoading;

  transformSpedizione(spedizione) {
    let tipoSpedizione = getTipoSpedizioneStr(spedizione['tipo_spedizione']);

    spedizione['tipoSpedizione'] = tipoSpedizione;

    let tempo = spedizione['lead_time_spedizione'];
    if (tempo == 0)
      spedizione['tempo'] = 'Non specificato';
    else {
      let giorni = Math.floor(tempo / 24);
      let ore = tempo % 24;
      
      let giorni_string = giorni == 1 ? 'giorno' : 'giorni';
      let ore_string = ore == 1 ? 'ora' : 'ore';

      let tempo_string = '';

      if (giorni) {
        tempo_string += `${giorni} ${giorni_string}`;
        if (ore)
          tempo_string += ' e ';
      }

      if (ore) {
        tempo_string += `${ore} ${ore_string}`;
      }

      spedizione['tempo'] = tempo_string;
    }

  }

  groupByType(spedizioni) {
    let sp : {[index:string]: any[]} = {};
    for (let spedizione of spedizioni) {
      if (!sp[spedizione.tipo_spedizione])
        sp[spedizione.tipo_spedizione] = [];
      sp[spedizione.tipo_spedizione].push(spedizione);
    }

    let adjustMinMaxRanges = (spedizioni, key : 'prezzo' | 'percentuale') => {
      spedizioni = spedizioni.sort((a,b) => a[key] - b[key]);
      
      // TODO merge/split/adjust by min_ordine/max_ordine for showing only shipping with min price
      // let groupedByPrice = {};
      // for (let spedizione of spedizioni) {
      //   let price = spedizione[key];
      //   if (!groupedByPrice[price])
      //     groupedByPrice[price] = [];
      //   groupedByPrice[price].push(spedizione);
      // }

      // // @ts-ignore
      // let prices = Object.keys(groupedByPrice).sort((a, b) => a - b);
      // let ranges : {start: number, end: number}[] = [];

      // for (let price of prices) {
      //   // adjust range
      //   for (let spedizione of groupedByPrice[price]) {
      //     for (let range of ranges) {
      //       if (range.start)
      //     }
      //   }

      //   // add new ranges
      //   for (let spedizione of groupedByPrice[price]) {
      //     ranges.push({start: spedizione.min_ordine, end: spedizione.max_ordine});
      //   }

      //   // merge ranges
      //   function merge(segments) {
      //     const inp = segments.map(s => ({...s}));
      //     inp.sort((a, b) => a.start - b.start);
      //     const out = [];
      //     let s = inp[0];
      //     for (let i = 1; i < inp.length; ++i) {
      //       if (inp[i].start <= s.end) {
      //         s.end = Math.max(s.end, inp[i].end);
      //       } else {
      //         out.push(s);
      //         s = inp[i];
      //       }
      //     }
      //     out.push(s);
      //     return out;
      //   }
      //   ranges = merge(ranges);
      // }

      // if want to merge ranges of shipping with same price
      // let groupedByPrice = {};
      // for (let spedizione of spedizioni) {
      //   let price = spedizione[key];
      //   if (!groupedByPrice[price])
      //     groupedByPrice[price] = { [spedizione['lead_time_spedizione']]: [spedizione] };
      //   else {
      //     let groupedByTime = groupedByPrice[price];
      //     if (!groupedByTime)

      //   }
      // }

      return spedizioni;
    }

    for (let [type, spedizioniByType] of Object.entries(sp)) {
      sp[type] = adjustMinMaxRanges(spedizioniByType.filter(sped => !sped.percentuale), 'prezzo').concat(
        adjustMinMaxRanges(spedizioniByType.filter(sped => sped.percentuale), 'percentuale'));
    }

    return sp;
  }

  getTypesAvailable() {
    return [1, 2, 0].filter(tipo => this.spedizioni[tipo]);
  }

  google2MyTidyDest(addressObj) {
    if (!addressObj || !addressObj.address)
        return null;

    const decode_address_component = (component) => {
        let decodedComponent = addressObj.address.find(obj => obj.types.includes(component));
        return decodedComponent ? decodedComponent.short_name : '';
    }

    let destinazione = {
        'latitudine': addressObj.lat,
        'longitudine': addressObj.lng,
        'stato': decode_address_component('country'),
        'prov': decode_address_component('administrative_area_level_2'),
        'citta': decode_address_component('administrative_area_level_3'),
        'cap': decode_address_component('postal_code'),
        'indirizzoDestinazione': decode_address_component('route'),
        'ragioneSocialeDestinazione': '_'
    };

    if (destinazione['indirizzoDestinazione']) {
        let numero_civico = decode_address_component('street_number');
        if (numero_civico)
            destinazione['indirizzoDestinazione'] += ', ' + numero_civico;
    }
    else
      destinazione['indirizzoDestinazione'] = '_';
    
    return destinazione;
  }

}
